var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-table',{staticStyle:{"height":"5rem"},attrs:{"columns":_vm.columns,"dataSource":_vm.datasource,"pagination":_vm.pagination,"loading":_vm.loading,"scroll":{ x: '100%', y: 'max-content' },"transformCellText":({ text }) => text || '-',"row-key":"pkId"},on:{"change":_vm.handlePagination}})
}
var staticRenderFns = []

export { render, staticRenderFns }